'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var styles = require('@material-ui/styles');
var Avatar = require('@material-ui/core/Avatar');
var ButtonBase = require('@material-ui/core/ButtonBase');
var Menu = require('@material-ui/core/Menu');
var ClickAwayListener = require('@material-ui/core/ClickAwayListener');
require('../ThemeProvider/ThemeProvider.js');
var colors = require('../ThemeProvider/colors.js');
require('../ThemeProvider/theme.js');
var AscIcon = require('@material-ui/icons/KeyboardArrowDownRounded');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Avatar__default = /*#__PURE__*/_interopDefaultLegacy(Avatar);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var Menu__default = /*#__PURE__*/_interopDefaultLegacy(Menu);
var ClickAwayListener__default = /*#__PURE__*/_interopDefaultLegacy(ClickAwayListener);
var AscIcon__default = /*#__PURE__*/_interopDefaultLegacy(AscIcon);

var useStyles = styles.makeStyles(theme => ({
  button: {
    display: 'flex',
    alignItems: 'center',
    height: props => props.height,
    backgroundColor: props => props.isOpen ? theme.palette.grey[200] : theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 3,
    paddingLeft: 24,
    paddingRight: 24
  },
  menu: {
    // zIndex: theme.zIndex.drawer + 2,
    // position: 'fixed',
    marginTop: 8,
    marginRight: 4 // borderRadius: theme.shape.borderRadius,
    // maxHeight: props => props.isOpen ? 'unset' : 0,
    // boxShadow: '0 2px 10px 0 rgb(21 27 38 / 10%)',
    // borderStyle: 'solid',
    // borderColor: theme.palette.divider,
    // borderWidth: props => props.isOpen ? 1 : 0,
    // Make sure we don't see the border when the menu is collapsed.

  },
  avatar: {
    height: props => props.height * (props.avatarOnly ? 0.8 : 0.6),
    width: props => props.height * (props.avatarOnly ? 0.8 : 0.6),
    fontSize: props => props.height * (props.avatarOnly ? 0.5 : 0.3),
    backgroundColor: props => props.color
  },
  nameWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    rowGap: 8,
    marginLeft: 8
  },
  name: _rollupPluginBabelHelpers.objectSpread2({
    maxWidth: 210,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }, theme.typography.subtitle2)
}));
var UserMenu = _ref => {
  var {
    color = colors.colors.indigo[500],
    avatar,
    initials,
    name,
    children,
    avatarOnly = false,
    height = 55
  } = _ref;
  var [anchor, setAnchor] = React__default['default'].useState(null);
  var isOpen = Boolean(anchor);
  var classes = useStyles({
    isOpen,
    color,
    avatarOnly,
    height
  });
  return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener__default['default'], {
    onClickAway: () => isOpen && setAnchor(null)
  }, /*#__PURE__*/React__default['default'].createElement(ButtonBase__default['default'], {
    id: "user-menu",
    className: classes.button,
    onClick: event => {
      event.stopPropagation();
      setAnchor(anchor ? null : event.currentTarget);
    }
  }, /*#__PURE__*/React__default['default'].createElement(Avatar__default['default'], {
    className: classes.avatar,
    src: avatar,
    alt: name,
    style: {
      textTransform: 'uppercase'
    }
  }, initials), Boolean(name) && !avatarOnly && /*#__PURE__*/React__default['default'].createElement("span", {
    className: classes.nameWrapper
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: classes.name
  }, name), /*#__PURE__*/React__default['default'].createElement(AscIcon__default['default'], null)), /*#__PURE__*/React__default['default'].createElement(Menu__default['default'], {
    className: classes.menu,
    open: Boolean(anchor),
    anchorEl: anchor,
    onClose: () => setAnchor(null),
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    }
  }, children)));
};
UserMenu.propTypes = {
  color: index.string,
  avatar: index.string,
  initials: index.string,
  name: index.string,
  children: index.node,
  avatarOnly: index.bool
};

exports.UserMenu = UserMenu;
